import React from 'react';

import { withChakraAs } from '../../utils/withChakraAs';
import type { TextProps } from '../Text/Text';
import { Text } from '../Text/Text';

export type CardDescriptionProps = Omit<
  TextProps<'p'>,
  'size' | 'variant' | '__orbitStyleConfig'
>;

export const CardDescription = withChakraAs<CardDescriptionProps, 'p'>(
  (props) => {
    return <Text {...props} variant="subtitle" />;
  },
);
